import React from 'react';

const UndoIcon = () => (
    <svg fill="#000000" width="800px" height="800px" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.87,11.14h-13l5.56-5.49A1,1,0,0,0,12,4.22L4,12.13,12,20a1,1,0,0,0,1.41-1.42L7.86,13.14h13a9.08,9.08,0,0,1,9.13,9,9,9,0,0,1-5,8A1,1,0,0,0,25.93,32a11,11,0,0,0-5.06-20.82Z"></path>
        <rect x="0" y="0" width="36" height="36" fillOpacity="0"/>
    </svg>
);

export default UndoIcon;
